import SamuelProfile from "../../components/SamuelProfile/SamuelProfile";

export default function SamuelProfilePage() {
    return (
        <SamuelProfile />
    )
};